import React, { Component } from 'react';
import $ from 'jquery';
import SlidingPanels from '../components/SlidingPanels';

require('jquery.scrollto');

export default class About extends Component {
    componentDidMount() {
        this.props.clearSlides();
        $.get('/data/slides/about.json').done(function (data) {
            for (let i = 0, len = data.length; i < len; i++) {
                this.props.addSlide(data[ i ]);
            }
        }.bind(this));

        $(window).scrollTo(30, '0.5s');

        document.title = `About - C&A Assembly & Installation Solution`;
    }

    render() {
        return (
            <div>
                <SlidingPanels {...this.props} />

                <div className="container">
                    <div className="row">
                        <div className="col-xs-12">
                            <h1>About</h1>

                            <p>A lot of people, when they buy furniture, they want their furniture to be assembled by someone with the greatest skill and care. C&amp;A Assembly &amp; Installation Solution can help
                                you out. All our team members have professional assembling skills. We look after every piece of your furniture with great care, provide great customer service and will be on time at
                                your place.</p>

                            <p>We even provide a service called "Same Day Service" or "Next Day Service". That means if you bought some furniture that can't fit into your car and needs to be picked up, delivered
                                and assembled; We can do it for you as the same or next day, so you can go to the next stop to keep shopping.</p>

                            <p>All our team members are using qualified and professional tools to assemble all your furniture. We make sure all your furniture will finish in the area that you want. Nice and
                                neat.</p>

                            <p>You only need to sit back, relax, and enjoy using your furniture.</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/About.js